import React from 'react';
import { Form, Input } from 'antd';
import PhoneNumberMask from '../../../../common/inputs/AuthorizationInputs';

const Phone = ({ form, disabled }) => {
  const { getFieldDecorator } = form;

  return (
    <div className="offer-card__item">
      <span className="label">Телефон:</span>
      <Form.Item>
        {getFieldDecorator('phoneCode')(
          <Input style={{ width: 80 }} disabled={disabled} />
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('phoneNumber')(
          <PhoneNumberMask
            autoComplete="off"
            name="phoneNumber"
            mask="(###) ###-##-##"
            maxLength={15}
            disabled={disabled}
            placeholder="Укажите номер телефона"
            style={{ width: 224 }}
          />
          // <Input  style={{ width: 224 }} disabled={disabled} />
        )}
      </Form.Item>
    </div>
  );
};

export default Phone;
